import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=0c78f6d0&scoped=true&"
import script from "./ProductGallery.js?vue&type=script&lang=js&"
export * from "./ProductGallery.js?vue&type=script&lang=js&"
import style0 from "./ProductGallery.scss?vue&type=style&index=0&id=0c78f6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78f6d0",
  null
  
)

export default component.exports